import { RouteParam } from 'src/types';

import { GenericCategoryRoute } from './generic-category.types';

const genericCategoryRouteValues = new Set<string>(Object.values(GenericCategoryRoute));

export function isGenericCategoryRoute(category: RouteParam): category is GenericCategoryRoute {
  return typeof category === 'string' && genericCategoryRouteValues.has(category);
}
